export const cartHelpers = {
    methods: {
        filterPrice(price) {
            let formattedPrice = price.toString(); // just in case data is passed through as integer
            if (!formattedPrice.includes('.00')) {
            // keeps decimal places if price does not end in .00
            formattedPrice = parseFloat(formattedPrice).toFixed(2);
            } else {
            formattedPrice = parseFloat(formattedPrice).toFixed(0); // drops $.00 if price is even number
            }
            return `$${formattedPrice}`;
        },
        isChoiceItem(lineItem) {
            return lineItem.title.toLowerCase().includes('ddc_'); 
        },
        cartContainsShippableItem() {
          for (var i = 0; i < this.cart.items.length; i++) {
            if (this.cart.items[i].requires_shipping) {
              return true;
            }
          }
          return false;
        },
        cartContainsRouteInsuranceItem() {
          for (var i = 0; i < this.cart.items.length; i++) {
            if (this.cart.items[i].product_id === 3940285775933) {
              return true;
            }
          }
          return false;
        },
        cartContainsDonationCheckboxItem() {
          for (var i = 0; i < this.cart.items.length; i++) {
            if (this.cart.items[i].variant_id === 40511363612733) {
              return true;
            }
          }
          return false;
        },
    },
    
};